import { BaseWithId } from "./base";

export class Inbox extends BaseWithId {
    public id: string;
    public client_id: string;
    public receiver_id: string;
    public sender_id: string;
    public order_id: string;
    public order_number: string;
    public provider: string;
    public vin: string;
    public creation_date: Date;
    public order_state: string;

    constructor(json?: any) {
        super(json);
    }
} 